import http from '@/utils/http';
const call = async (action, data) => {
  const response = await http({ url: '/api/admin/v1/contractProjectOrderChange/' + action, data, method: 'post' });
  if (response?.code !== 0) throw new Error(response?.msg || '变更请求失败');
  return response.data;
};
export default Object.fromEntries(['actualPreview','detail','recordActual','propose','confirm','reject','withdraw'].map(action => [action, data => call(action,data)]));
